import type { DialogConfig } from '../shared/types';

export const FREE_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'automation-free-limit-modal',
	dialogType: 'modal',
};

export const STANDARD_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'automation-free-limit-modal',
	dialogType: 'modal',
};
